import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminOrgAiPage } from "@/features/admin/org-ai";

const search = z.object({ tab: z.enum(["activity", "models"]).optional().catch(undefined) });

/** ALP-86: org → AI activity + AI models (un-nested from /admin/orgs so the Orgs tab stays highlighted). */
export const Route = createFileRoute("/admin/orgs_/$orgId/ai")({
  validateSearch: search,
  head: () => ({ meta: [{ title: "AI · Organization · Admin · Malfak" }] }),
  component: OrgAiRoute,
});

function OrgAiRoute() {
  const { orgId } = Route.useParams();
  const { tab } = Route.useSearch();
  return <AdminOrgAiPage key={orgId} orgId={orgId} tab={tab ?? "activity"} />;
}
